<section class="main" [class.sidebar-pinned]="isSideBarPinned">

  <div class="main-sidenav">
    <pf-side-navigation-bar
      [headline]="headline"
      [subHeadline]="subHeadline"
      [statusLabel]="statusLabel"
      [statusColor]="statusColor"
      [backButtonLabel]="backButtonLabel"
      [backButtonUrl]="backButtonUrl"
      [steps]="steps$ | async"
      (sideBarPinChanged)="isSideBarPinned = $event"
    ></pf-side-navigation-bar>
  </div>

  <div class="main-content">
    <div class="main-content-wrapper">
      <div class="main-content-body">
        <router-outlet></router-outlet>
      </div>
    </div>


    <div class="main-content-footerbar">
      <one-limit-blocker #limitBlocker [blockerMessage]="upsellBlocked" [id]="RouteHeaderUrl.upsell">
        <pf-footerbar-navigation></pf-footerbar-navigation>
      </one-limit-blocker>
    </div>
  </div>

</section>
<!-- <one-video-tutorial-trigger-button
  videoId="WZYrIeaZpcY"
></one-video-tutorial-trigger-button> -->
<ng-template #upsellBlocked>
  <div class="Card">
    <div class="text-danger">
      {{ 'upsell_page.builder.limit_block' | transloco }}
      <button class="one-button xs outline red ml-2" [routerLink]="['/settings/billing/subscriptions']">{{ 'upsell_page.upgrade_plan' | transloco }}</button>
    </div>
  </div>
</ng-template>